import type {
  ChatEndedData,
  ChatOutcomeData,
  ChatReactionData,
  ChatStartedData,
  ChatSubmittedData,
} from '../../types/api/help-hub-events';

export {
  EndReason,
  OutcomeChannel,
  Reaction,
  ReactionReason,
} from '../../types/api/help-hub-events';

type BaseEvent = {
  eventType: string;
  sessionId: string;
  storeId: string;
  tenant: string;
  time: string;
  userId: string;
  version: number;
};

export type ChatStartedEvent = {
  data: ChatStartedData;
} & BaseEvent;

export type ChatSubmittedEvent = {
  data: ChatSubmittedData;
} & BaseEvent;

export type ChatEndedEvent = {
  data: ChatEndedData;
} & BaseEvent;

export type ChatReactionEvent = {
  data: ChatReactionData;
} & BaseEvent;

export type ChatOutcomeEvent = {
  data: {
    category: string;
    channel?: ChatOutcomeData['channel'];
    pid: string;
    ticketId?: string | null;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ticketRaised: boolean;
  };
} & BaseEvent;

export type ChatViewSourceEvent = {
  data: {
    category: string;
    pid: string;
  };
} & BaseEvent;

export type ChatEvent =
  | ChatStartedEvent
  | ChatSubmittedEvent
  | ChatEndedEvent
  | ChatReactionEvent
  | ChatOutcomeEvent
  | ChatViewSourceEvent;
